(function ($) {
    
    function arrowClicks(){
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            
            var parentLi = $(this).parent();
            
            //hide all other top level nav items
            parentLi.siblings().hide();
            parentLi.find('> a').hide();
            parentLi.find('> .arrow').hide();
            
            //add active class
            $( this ).next().addClass('active');

            //set static css to LI
            $( this ).closest('.menu-item').addClass('static');
        });
        $('.sidr__menu-back').on('click',function(){
            var parentLi = $(this).parents('.menu-item'),
                menuCloseId = $( this ).data('sidr-menu'),
                megaMenu = $( this ).find('.megamenu');
            
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).closest('.megamenu').removeClass('active');

            //remove static css from LI
            $( this ).closest('.menu-item').removeClass('static');
            
            //show all other top level nav items
            parentLi.siblings().show();
            parentLi.find('> a').show();
            parentLi.find('> .arrow').show();
        });
    }

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'));

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        $('#sitesearch--toggle').on('click',function(e) {
            $("html, body").animate({ scrollTop: 0 }, "fast");
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('#sitesearch').toggleClass('active');
        });
        $('#sitesearch--close').on('click',function(e) {
            $('#sitesearch').removeClass('active').unbind();
        });

        
        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<div id="mobile-menu">';
                
                sidrHtml += '<div class="sidr__header"><a href="/" class="sidr__logo">' + $('.site-logo .logo-img').html() + '</a><span class="sidr__close" aria-label="Close Menu"></span></div>';
                
                sidrHtml += '<div class="sidr__inner">';
                if($('.main-navigation .nav-menu').length){
                    sidrHtml += '<div class="sidr__mainnav"><ul class="nav-menu">' + $('.main-navigation .nav-menu').html() + '</ul></div>';
                }
//                if($('.main-navigation .subnav-menu').length){
//                    sidrHtml += '<div class="sidr__subnav"><ul>' + $('.main-navigation .subnav-menu').html() + '</ul></div>';
//                }
                if($('#site-header-contact').length){
                    sidrHtml += '<div class="sidr__subnav">';

                    sidrHtml += $('#site-header-contact').html();
//                    var contactUrl = $('#site-header-contact').attr('href');
//                    sidrHtml += '<a href="' + contactUrl + '" class="button button-primary-default" id="sidr__contact">' +  $('#site-header-contact').html() + '</a>';
                    
                    sidrHtml += '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</div>';
                    
                return sidrHtml;
                
            },
            onOpen: function() {
                var rawheaderHeight = $("#masthead").height(),
                    headerHeight = rawheaderHeight + 4;
                
                $('#sitesearch').removeClass('active').unbind();
                
//                $('#mobile-trigger').addClass('active');
                
                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $( '.sidr-overlay' ).remove();
                $('#mobile-trigger').removeClass('active');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });

        $('.sidr__close').click(function() {
            $('#sitesearch').removeClass('active').unbind();
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
        });
        
        
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
        $( '.js-modal-popup' ).magnificPopup({
            type: 'inline',
            preloader: false
        });

	});
    
//    $(document).on("mousedown touchstart",function(event){
//        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
//            $('#sitesearch').addClass('active');
//        }
//        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
//            $('#sitesearch').removeClass('active');
//        }
//        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
//            $("#sitesearch").removeClass('active');
//        } 
//    });
    
    //on resize
//    $(window).on('resize', function(){
//        AOS.refresh();
//    });
//    $("#page").on('scroll', function () {
//        AOS.refresh();
//    });
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
    });
    
})(jQuery);